exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1zGGN {\n    padding: 0 80px;\n}\n\n.divition_PLDnV {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.infoContainer_1zGGN > p {\n    text-align: center;\n    font-weight: 800;\n    font-style: italic;\n}\n\n.infoContainer_1zGGN > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.noPaddingBottom_2xGu5 {\n    padding-bottom: 0 !important;\n}\n\n.noPaddingBottom_2xGu5 > [class*=\"rowCondition\"] {\n    padding-top: 0;\n}\n\n.titleBold__VF2j {\n    font-weight: 800;\n}\n\n.gapSection12_1lnfI {\n    height: 30px;\n}\n\n.alignment_3cX-S {\n    text-align: center;\n}\n\n.signatureSize_2mpsB img {\n    max-width: 200px;\n    max-height: 80px;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1zGGN",
	"divition": "divition_PLDnV",
	"noPaddingBottom": "noPaddingBottom_2xGu5",
	"titleBold": "titleBold__VF2j",
	"gapSection12": "gapSection12_1lnfI",
	"alignment": "alignment_3cX-S",
	"signatureSize": "signatureSize_2mpsB"
};